// extracted by mini-css-extract-plugin
export default {"button-content":"help-button_button-content__pTmEo"};